import { useEffect, useSyncExternalStore } from "react";
import {
  getIsOffline,
  setIsOffline,
  subscribeToConnection,
} from "../utils/connectionStatus";

const useOfflineDetection = () => {
  const isOffline = useSyncExternalStore(subscribeToConnection, getIsOffline);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);

    window.addEventListener("online", handleOnline);
    return () => window.removeEventListener("online", handleOnline);
  }, []);

  return isOffline;
};

export default useOfflineDetection;
